import { plainToInstance, Type } from 'class-transformer'
import { Entity } from '@core/entities/entity'
import { IChecklistApprovalReviews } from '@core/entities/checklist/ChecklistApprovalReviews/IChecklistApprovalReviews'
import { ChecklistApprovalWrapper } from '@core/entities/checklist/ChecklistApprovalWrapper'
import { ChecklistNominatedApprovers } from '@core/entities/checklist/ChecklistNominatedApprovers'

export class ChecklistApprovalReviews extends Entity<IChecklistApprovalReviews> {
  @Type(() => ChecklistApprovalWrapper)
  approvals: Array<ChecklistApprovalWrapper>

  nextApprovalId?: string

  @Type(() => ChecklistNominatedApprovers)
  nominatedApprovers?: ChecklistNominatedApprovers

  public static new(payload: unknown): ChecklistApprovalReviews {
    const entity = plainToInstance(ChecklistApprovalReviews, payload)

    return entity
  }

  public getReviews(
    action?: 'APPROVED' | 'REJECTED',
  ): Array<ChecklistApprovalWrapper> {
    const reviews = this.approvals ?? []

    return action
      ? reviews.filter((review) => review.action === action)
      : reviews
  }

  public getNextApproval(): ChecklistApprovalWrapper | undefined {
    return this.approvals?.find(
      (wrapper) => wrapper.approval?.id === this.nextApprovalId,
    )
  }

  /**
   * Comma-separated names of the approvers nominated for [approvalId] (empty if
   * none). Mirrors permit's getNominatedApproverNamesForApproval — used to show
   * assignees on a pending approval stage.
   */
  public getNominatedApproverNames(approvalId?: string): string {
    const approvers = this.nominatedApprovers?.approvers ?? []
    const relevant = approvalId
      ? approvers.filter((approver) => approver.targetApprovalId === approvalId)
      : approvers
    return relevant
      .flatMap((approver) => approver.targetApprovers?.map((t) => t.name) ?? [])
      .join(', ')
  }

  public hasNominatedApprovers(): boolean {
    return this.nominatedApprovers?.approvers?.length > 0
  }
}
